// One identity rule for a plan row in the quote wizard's plan picker.
//
// Plans in that list come from GET /api/plan-source/plans, which serves our own
// plan library and returns THREE id-ish fields:
//   planId      — our internal plans.id (number). Always present for a library plan.
//   id          — a STRING: the provider id when there is one, else our id as text.
//   wordBrownId — the provider id, null for anything not synced from Word & Brown.
//
// A selected plan is stored with `id: planId`, so `planId` has to win — comparing
// on `id` alone made a library plan never match its own selected copy, so it could
// be clicked over and over, each click inserting a duplicate plan row.

export function planIdentity(plan: any): string | null {
  const value = plan?.planId ?? plan?.wordBrownId ?? plan?.id;
  return value == null ? null : String(value);
}

// True when both sides are the same plan. Null identity never matches — not even
// another null, or two unrelated half-formed rows would collapse together.
export function isSamePlan(a: any, b: any): boolean {
  const left = planIdentity(a);
  return left != null && left === planIdentity(b);
}
